import { Link } from "react-router-dom";
import { MaskLines } from "@/components/site/Reveal";

const sections = [
  {
    title: "30-day returns",
    body: "You can return any item within 30 days of delivery as long as it's unused, in its original condition and original packaging. Include your order number (it starts with ME-) in everything you send us.",
  },
  {
    title: "How to start a return",
    body: "Email melic@melicshop.com with your order number and the item(s) you'd like to return, or call (484) 493-2756. We'll reply with return instructions and the address to ship to.",
  },
  {
    title: "Refunds",
    body: "Once your return arrives and is inspected, we refund the full item price to your original payment method — card refunds run through Stripe, PayPal refunds through PayPal. Banks typically post the money within 5–7 business days after we issue it.",
  },
  {
    title: "Return shipping",
    body: "Return shipping is paid by the customer, unless the item arrived damaged, defective or wrong — then we cover it.",
  },
  {
    title: "Damaged, defective or wrong items",
    body: "Contact us within 7 days of delivery with your order number and a photo of the item. We'll send a replacement or a full refund — your choice — at no cost to you.",
  },
  {
    title: "What can't be returned",
    body: "For hygiene reasons, opened beauty and personal-care items can't be returned unless they arrived damaged or defective.",
  },
  {
    title: "Order never arrived or arrived damaged in transit",
    body: "Reach out and we'll investigate with the carrier and either reship or refund — you'll never be left paying for something that didn't arrive intact.",
  },
];

export default function Returns() {
  return (
    <div className="mx-auto max-w-3xl px-5 pb-32 pt-12 md:pt-20" data-testid="returns-page">
      <p className="eyebrow text-[var(--terra-deep)]">Returns &amp; refunds</p>
      <MaskLines
        as="h1"
        className="font-display mt-3 text-5xl leading-[1] tracking-tight sm:text-6xl"
        lines={[{ text: "Not in love?" }, { text: "Send it back.", className: "italic text-[var(--terra)]" }]}
      />
      <p className="mt-6 text-base leading-relaxed text-[var(--ink-soft)]">
        We want you happy with everything you order. Here's exactly how returns and refunds work at Melic — no fine-print games.
      </p>
      <div className="mt-12 space-y-4">
        {sections.map((s) => (
          <div key={s.title} className="rounded-2xl border border-[var(--line)] bg-white/50 p-6 md:p-8" data-testid={`returns-section-${s.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
            <h2 className="font-display text-2xl md:text-3xl">{s.title}</h2>
            <p className="mt-3 text-sm leading-relaxed text-[var(--ink-soft)] md:text-base">{s.body}</p>
          </div>
        ))}
      </div>
      <div className="mt-10 rounded-2xl bg-[var(--ink)] p-6 text-[var(--bone)] md:p-8">
        <p className="font-display text-2xl">Questions about an order?</p>
        <p className="mt-3 text-sm text-stone-300">Email <a href="mailto:melic@melicshop.com" className="link-u font-semibold text-[var(--bone)]">melic@melicshop.com</a> or call <a href="tel:+14844932756" className="link-u font-semibold text-[var(--bone)]">(484) 493-2756</a> — include your order number and we'll sort it out.</p>
        <Link to="/shop" className="mt-6 inline-flex rounded-full bg-[var(--terra)] px-7 py-3.5 text-sm font-semibold text-[#241a06] transition-colors hover:bg-[var(--terra-deep)]" data-testid="returns-continue-shopping">Continue shopping</Link>
      </div>
    </div>
  );
}
